Vue.component('contact-list', require('./ContactList').default);
Vue.component('contact-list-item', require('./ContactListItem').default);
Vue.component('contact-edit', require('./ContactEdit').default);
Vue.component('group-edit', require('./GroupEdit').default);
Vue.component('contact-groups', require('./ContactGroups').default);
Vue.component('contact-groups-list', require('./ContactGroupsList').default);
Vue.component('contacts-csv-importer', require('./ContactsCsvImporter').default);
Vue.component('blocked-contact-list', require('./BlockedContactList').default);
Vue.component('add-new-contact-modal', require('./AddNewContactModal').default);
Vue.component('add-new-group-modal', require('./AddNewGroupModal').default);
Vue.component('add-contact-to-group-modal', require('./AddContactToGroupModal').default);
Vue.component('contacts', require('./Contacts').default);
Vue.component('contacts-page', require('./ContactsPage').default);
